var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8848 7.5C16.8848 11.0899 13.9746 14 10.3848 14C8.11405 14 6.11529 12.8356 4.95296 11.0714L4.12081 11.6262C5.46247 13.6589 7.767 15 10.3848 15C14.5269 15 17.8848 11.6421 17.8848 7.5C17.8848 3.35786 14.5269 0 10.3848 0C6.24263 0 2.88477 3.35786 2.88477 7.5C2.88477 7.76927 2.89896 8.03522 2.92663 8.29715H3.93316C3.90121 8.03591 3.88477 7.76987 3.88477 7.5C3.88477 3.91015 6.79491 1 10.3848 1C13.9746 1 16.8848 3.91015 16.8848 7.5Z",
    fill: "#9A9AA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.70312L3.39062 8.29687L5.78125 6.70312",
    stroke: "#9A9AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedArrow);
export default __webpack_public_path__ + "static/media/roundedArrow.30ae1753b663204cfbccffaa16e25064.svg";
export { ForwardRef as ReactComponent };